import extendedConfig from '../../tenants.js'

export const childrenPaths = [
  {
    path: '/bhusers/:id/general',
    name: 'BH User General',
    meta: {
      menuTitle: 'General',
      title: `${extendedConfig.VUE_MAIN_TITLE} Team`,
      icon: 'bhi-home',
      requiresAuth: true,
      disableLink: true,
    },
    component: () => import('@/views/bhUsers/BhUserGeneral.vue'),
  },
  {
    path: '/bhusers/:id/participants',
    name: 'BH User Patients',
    meta: {
      menuTitle: 'Participants',
      title: `${extendedConfig.VUE_MAIN_TITLE} Team`,
      icon: 'bhi-book',
      requiresAuth: true,
      disableLink: true,
    },
    hideOnRole: [2, 3],
    hideOnRoleAlsoAdmins: true,
    component: () => import('@/views/bhUsers/BhUserPatients.vue'),
  },
  // {
  //   path: "/bhusers/:id/timed-release",
  //   name: "BH User Timed release",
  //   meta: {
  //     menuTitle: "Timed release",
  //     title: "BH User",
  //     icon: "bhi-clock"
  //   },
  //   component: () => import("@/views/error/NotFound.vue")
  // },
  // {
  //   path: "/bhusers/:id/smart-survey",
  //   name: "BH User Smart Survey",
  //   meta: {
  //     menuTitle: "Smart Survey",
  //     title: "BH User",
  //     icon: "bhi-content-paste"
  //   },
  //   component: () => import("@/views/error/NotFound.vue")
  // },
  // {
  //   path: "/bhusers/:id/chat",
  //   name: "BH User Chat",
  //   meta: {
  //     menuTitle: "Chat",
  //     title: "BH User",
  //     icon: "bhi-forum"
  //   },
  //   component: () => import("@/views/error/NotFound.vue")
  // },
  // {
  //   path: "/bhusers/:id/user-library",
  //   name: "BH User User library",
  //   meta: {
  //     menuTitle: "User library",
  //     title: "BH User",
  //     icon: "bhi-book-open"
  //   },
  //   component: () => import("@/views/error/NotFound.vue")
  // }
]

export default [
  {
    path: '/bhusers',
    name: 'BhUSers',
    meta: {
      title: `${extendedConfig.VUE_MAIN_TITLE} Team`,
      icon: 'bhi-heart',
      requiresAuth: true,
    },
    hideOnRole: [4, 5, 6, 7],
    component: () => import('@/views/BhUsers.vue'),
  },
  {
    path: '/bhusers/:id',
    name: 'BH User',
    hidden: true,
    meta: {
      title: `${extendedConfig.VUE_MAIN_TITLE} Team`,
      requiresAuth: true,
    },
    // do we need this redirection?
    redirect: {
      name: 'BH User General',
    },
    component: () => import('@/views/BhUser.vue'),
    children: childrenPaths,
  },
]
